import React from 'react'
import { MuiThemeProvider } from '@material-ui/core'
import { blueTheme } from '../themes'

export const BlueThemeProvider = ({ children }) => (
  <MuiThemeProvider theme={blueTheme}>{children}</MuiThemeProvider>
)
